export enum ThemeType {
  Rappi8 = 'th-rappi-8',
  Rappi7Light = 'th-rappi-7-light',
  Rappi7Dark = 'th-rappi-7-dark',
  RappiPay = 'th-rappi-pay',
}

export const DefaultTheme = ThemeType.Rappi8 as string;
